import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import React from "react";
const useMergeRefs = refs => React.useCallback(value => {
  _forEachInstanceProperty(refs).call(refs, ref => {
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref != null) {
      /* eslint-disable no-param-reassign */
      ref.current = value;
    }
  });
}, refs); // eslint-disable-line react-hooks/exhaustive-deps

export default useMergeRefs;